import {SubscriptionStatus, SubscriptionTariff} from '@entities/subscriptions/types';
import api from '@shared/api';

const SUBSCRIPTION_PATH = '/subscription';

export const fetchSubscription = async (tin: string) =>
    (
        await api.get<SubscriptionStatus>(`${SUBSCRIPTION_PATH}/api/subscription/status`, {
            params: {tin},
        })
    ).data;

export const fetchTariffs = async () =>
    (await api.get<SubscriptionTariff[]>(`${SUBSCRIPTION_PATH}/api/subscription/tariffs`)).data;

export const activateTrial = async (tin: string) =>
    (
        await api.post<SubscriptionStatus>(
            `${SUBSCRIPTION_PATH}/api/subscription/trial/activate`,
            null,
            {
                params: {tin},
            },
        )
    ).data;

export const paySubscription = async ({tin, tariffId}: {tin: string; tariffId: string}) =>
    (
        await api.post<ArrayBuffer>(`${SUBSCRIPTION_PATH}/api/subscription/pay`, null, {
            params: {tin, tariffId},
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
            },
        })
    ).data;

export const cancelSubscription = async (tin: string) =>
    (
        await api.post<SubscriptionStatus>(
            `${SUBSCRIPTION_PATH}/api/subscription/cancel-payment`,
            null,
            {
                params: {tin},
            },
        )
    ).data;

export const fetchPaymentInvoice = async (tin: string) =>
    (
        await api.get<ArrayBuffer>(`${SUBSCRIPTION_PATH}/api/subscription/payment-invoice`, {
            params: {tin},
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
            },
        })
    ).data;
